export interface LocationType {
  value: string; // used for moment-timezones
  label: string; // what the user sees
}

export let initialLocation: LocationType = {
  value: "America/New_York",
  label: "New York",
};
